<template>
  <v-card class="mx-auto p-1 my-0" flat max-width="400">
    <template v-if="getImages && getImages.length > 0">
      <div v-if="getImages.length === 1" class="single-image-wrapper">
        <v-img
          :src="getImages[0].url"
          :aspect-ratio="16/9"
          class="cursor-pointer rounded-lg"
        ></v-img>
      </div>

      <div v-else-if="getImages.length > 1">
        <v-carousel
          v-if="value.mode === 'slider'"
          height="200"
          hide-delimiters
          cycle
        >
          <v-carousel-item v-for="(img, i) in getImages" :key="i">
            <v-img :src="img.url" :data-source="img.url" />
          </v-carousel-item>
        </v-carousel>

        <v-row v-else dense no-gutters class="mt-4 pa-1">
          <v-col
            v-for="(card, index) in getImages"
            :key="index"
            :cols="index === 0 ? 12 : 6"
            class="pa-1"
          >
            <v-card style="border-radius: 18px !important">
              <v-img
                v-if="isImg"
                :aspect-ratio="16 / 9"
                :src="card.url"
                class="align-end"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              >
                <v-card-title
                  class="text-white"
                  style="font-size: 8pt; white-space: pre-line"
                  v-text="card.description"
                />
              </v-img>

              <iframe
                v-else
                :src="card.url"
                style="width: 100%; border: none"
              />
            </v-card>
          </v-col>
        </v-row>
      </div>
    </template>
  </v-card>
</template>

<script>
export default {
  name: "headerImage",

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    isImg: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    getImages() {
      return this.value?.gallery?.[0]?.images || [];
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
